import { render, staticRenderFns } from "./AutoCheckVMC.vue?vue&type=template&id=b8908a3a&"
import script from "./AutoCheckVMC.vue?vue&type=script&lang=js&"
export * from "./AutoCheckVMC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports